import { CampaignModel, ProfileModel } from '@pukka/api';
import { isAfter, isFuture, isSameDay } from 'date-fns';

import { CustomerDisplayFormSchemaType } from './customerDisplayFormSchema';

function today() {
  const tdy = new Date();

  tdy.setHours(0, 0, 0, 0);

  return tdy;
}

function tomorrow() {
  const tdy = new Date();
  const tmrw = new Date(tdy);

  tmrw.setDate(tmrw.getDate() + 1);

  tmrw.setHours(0, 0, 0, 0);

  return tmrw;
}

function getOutletName(outlets: ProfileModel.Outlet[], outletId: ProfileModel.Outlet['id']) {
  return outlets?.find((outlet) => outlet.id === outletId)?.name || '';
}

function getCampaignStatus(campaign: CampaignModel.Detailed): CampaignModel.Status {
  if (!campaign.is_active) {
    return 'inactive';
  }

  if (campaign.start_date && isAfter(new Date(campaign.start_date), new Date())) {
    return 'scheduled';
  }

  if (campaign.end_date && isAfter(new Date(campaign.end_date), new Date())) {
    return 'active';
  }

  if (campaign.start_date && campaign.end_date === null) {
    return 'active';
  }

  return 'inactive';
}

function constructPayload(data: CustomerDisplayFormSchemaType, status?: CampaignModel.Status) {
  const { name, images, duration, outletIds, setTimePeriod, timePeriod } = data;
  const { startDate, endDate } = timePeriod;

  if (!setTimePeriod && status !== 'active' && status !== 'inactive') {
    const tmrw = tomorrow();

    startDate.setFullYear(tmrw.getFullYear(), tmrw.getMonth(), tmrw.getDate());
  }

  const now = new Date();

  if (setTimePeriod && isSameDay(startDate, now)) {
    // start immediately if today is selected
    startDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds());
  } else if (setTimePeriod && isFuture(startDate)) {
    startDate.setHours(0, 0, 0, 0);
  }

  endDate.setHours(23, 59, 59, 59);

  const payload: CampaignModel.CreateRequest = {
    name,
    images,
    duration,
    outlet_ids: outletIds,
    start_date: startDate.toISOString(),
    end_date: setTimePeriod ? endDate.toISOString() : null,
  };

  return payload;
}

function generateErrorOutlets(message: string) {
  const regExp = /\[([^)]+)\]/;
  const matches = regExp.exec(message);
  const outletList = JSON.parse(`${matches?.[0]}`);

  return outletList;
}

export { today, tomorrow, getOutletName, getCampaignStatus, constructPayload, generateErrorOutlets };
